import { RomanBlindsProductType } from '../../constants/productTypes';
import { ProductBuilderMachineState } from '../../types';

type RomanStatesByProductType = {
  [key in RomanBlindsProductType]: ProductBuilderMachineState[];
};

export const allRomanStates: ProductBuilderMachineState[] = [
  'colour',
  'lining',
  'driveControl',
  'fitting',
  'measurements',
  // 'measureInsurance',
  'chainType',
  'chainPosition',
  'extensionPole',
  'roomName',
  // 'shipping',
  'complete',
];

const romanChainStates = allRomanStates.filter(state => {
  const chainList: ProductBuilderMachineState[] = ['extensionPole'];
  return !chainList.includes(state);
});

const romanChainlessStates = allRomanStates.filter(state => {
  const chainLessList: ProductBuilderMachineState[] = [
    'chainType',
    'chainPosition',
  ];
  return !chainLessList.includes(state);
});

export const romanStatesByProductType: RomanStatesByProductType = {
  'Roman Blinds Chain': romanChainStates,
  'Roman Blinds Chainless': romanChainlessStates,
};
